import * as React from 'react';
import { SVGProps } from 'react';
const HospitalBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.70801 4.62749C6.09464 4.01379 5.0998 4.01345 4.48597 4.62674L4.19259 4.91986C3.63458 4.76128 3.01028 4.9032 2.5709 5.34553C1.92255 5.99828 1.92255 7.05766 2.5709 7.71041L2.91797 8.05982V12.5003H1.66797V13.3337H2.52235C2.25223 13.5984 2.08464 13.9673 2.08464 14.3753C2.08464 15.1807 2.73755 15.8337 3.54297 15.8337C4.34839 15.8337 5.0013 15.1807 5.0013 14.3753C5.0013 13.9673 4.83372 13.5984 4.56359 13.3337H15.439C15.1689 13.5984 15.0013 13.9673 15.0013 14.3753C15.0013 15.1807 15.6542 15.8337 16.4596 15.8337C17.2651 15.8337 17.918 15.1807 17.918 14.3753C17.918 13.9673 17.7504 13.5984 17.4803 13.3337H18.3346V12.5003H16.668V11.2034C17.3854 11.0272 17.918 10.375 17.918 9.59741C17.918 8.68461 17.1841 7.94466 16.2789 7.94466H7.54714C7.51318 7.94466 7.48055 7.93103 7.45651 7.90682L7.30384 7.75316L7.45734 7.59978C8.07122 6.98645 8.07155 5.9917 7.45809 5.37795L6.70801 4.62749ZM6.71659 7.16191L6.86834 7.01028C7.15659 6.72228 7.15676 6.25524 6.86872 5.96707L6.11864 5.21661C5.83055 4.92836 5.36326 4.9282 5.07497 5.21624L4.92893 5.36216L6.71659 7.16191ZM15.8346 12.5003H3.7513V8.89878L5.9493 11.1117C6.03743 11.2004 6.15684 11.2502 6.28139 11.2502H15.8346V12.5003Z"
      fill="#475CB0"
    />
  </svg>
);
export default HospitalBed;
